export function detectDeviceType(
  headers: Record<string, string>,
): "mobile" | "desktop" {
  const mobileHeader = headers["sec-ch-ua-mobile"];
  if (mobileHeader) {
    return mobileHeader === "?1" ? "mobile" : "desktop";
  }

  const userAgent = headers["user-agent"]?.toLowerCase() || "";
  const mobileKeywords = ["iphone", "ipad", "android", "mobile"];
  const isMobile = mobileKeywords.some((keyword) =>
    userAgent.includes(keyword),
  );

  return isMobile ? "mobile" : "desktop";
}
